/* Inspired from MaterialUI:
https://github.com/mui-org/material-ui/tree/master/packages/material-ui/src/RootRef */
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

/** Record an HTML dom node to a ref */
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    // eslint-disable-next-line no-param-reassign
    ref.current = value;
  }
}

/** A reference to the root of the position component */
class RootRef extends React.PureComponent {
  componentDidMount() {
    // eslint-disable-next-line react/no-find-dom-node
    setRef(this.props.rootRef, ReactDOM.findDOMNode(this));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.rootRef !== this.props.rootRef) {
      setRef(prevProps.rootRef, null);
      // eslint-disable-next-line react/no-find-dom-node
      setRef(this.props.rootRef, ReactDOM.findDOMNode(this));
    }
  }

  componentWillUnmount() {
    setRef(this.props.rootRef, null);
  }

  render() {
    return this.props.children;
  }
}

RootRef.propTypes = {
  /**
   * The children element.
   */
  children: PropTypes.element.isRequired,
  /**
   * The access to the DOM node of the children element.
   * Can be either a callback ref or a `React.createRef()`.
   */
  rootRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired
};

export default RootRef;
